module.exports = __webpack_public_path__ + "static/media/29BDOS15.a93ced93.jpg";